import {
  keys as defaultKeys,
  BreakpointValues,
} from '@material-ui/core/styles/createBreakpoints';

export type Breakpoint = import('@material-ui/core/styles/createBreakpoints').Breakpoint;

export interface MaxWidths {
  keys: Breakpoint[];
  values: BreakpointValues;
  width: (key: Breakpoint) => string;
  unit: string;
}

export interface MaxWidthsConfig {
  keys: Breakpoint[];
  values: BreakpointValues;
  unit: string;
}

const defaults: MaxWidthsConfig = {
  keys: defaultKeys,
  values: {
    xs: 20,
    sm: 20,
    md: 42,
    lg: 72,
    xl: 72,
  },
  unit: 'rem',
};

export default (mw = defaults): MaxWidths => ({
  ...mw,
  width: (k: Breakpoint) => `${mw.values[k]}${mw.unit}`,
});
